import { useTranslations } from 'use-intl';

/** "Amex ••1234", or "Card ••1234" when no name is saved, in the language the app shows. */
export function useCardLabel() {
  const t = useTranslations('consultantCards');
  return (card: { provider: string | null; last_four: string }): string =>
    t('label', { hasProvider: !!card.provider, provider: card.provider ?? '', lastFour: card.last_four });
}
